module.exports = __webpack_public_path__ + "static/media/newsletter_mobile.f28a121e.webp";